import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {PackageFieldConfigurationModel} from "../../models/package-field-configuration.model";
import {FieldCategoryType} from "../../types/field-category.type";
import {FieldType} from "../../types/field.type";
import {DefaultPackageConfigurationFieldsType} from "../../types/default-package-configuration-fields.type";
import {ValidationType} from "../../types/validation.type";
import {SettingsService} from "../../services/settings-service.service";
import {FieldValidationModel} from "../../models/field-validation.model";
import {CustomFieldModel} from "../../models/custom-field.model";

export class PackageConfigurationFieldTableRowComponent implements IController {
  form: any;
  field: PackageFieldConfigurationModel;
  isEditable: boolean | undefined;
  isDefault: boolean | undefined;
  genericFieldNameOptions: DefaultPackageConfigurationFieldsType[]
  isGeneric: boolean;
  onFieldChanged: Function;
  onDeleteField: Function;

  public readonly fieldCategoryTypesMap: typeof FieldCategoryType = FieldCategoryType;
  public readonly fieldCategoryTypesList: FieldCategoryType[];
  public readonly fieldTypesMap: typeof FieldType = FieldType;
  public readonly fieldTypesList: FieldType[];
  public readonly validationTypesMap: typeof ValidationType = ValidationType;
  public readonly validationTypesList: ValidationType[];

  constructor(private settingsService: SettingsService) {
    this.fieldCategoryTypesList = Object.values(FieldCategoryType);
    this.fieldTypesList = Object.values(FieldType);
    this.validationTypesList = Object.values(ValidationType);
  }

  $onChanges(changes: IOnChangesObject) {

  }

  onCategoryChanged(category) {
    let fieldCopy = angular.copy(this.field);

    fieldCopy.name = undefined;

    if (category === FieldCategoryType.Custom) {
      delete fieldCopy.type;

      fieldCopy.validation = this._resetValidation(fieldCopy.validation, false)
    }

    this.onFieldChanged({changedField: fieldCopy})
  }

  onValidationTypeChanged(validationType: ValidationType) {
    let fieldCopy = angular.copy(this.field);

    if (validationType !== ValidationType.RegularExpression) {
      delete fieldCopy.validation.expression;
      delete fieldCopy.validation.explanation;
    }
    this.onFieldChanged({changedField: fieldCopy})
  }

  onFieldTypeSelected(fieldType: FieldType) {
    let fieldCopy = angular.copy(this.field);

    if (fieldType !== FieldType.DropdownSingle && fieldType === FieldType.DropdownMultiple) {
      delete fieldCopy.options
    }

    fieldCopy.validation = this._resetValidation(fieldCopy.validation, fieldType === FieldType.Numeric)
    if(fieldType === FieldType.Numeric){
      fieldCopy.validation.type = ValidationType.Numeric;
    }

    this.onFieldChanged({changedField: fieldCopy})
  }

  onFieldNameSelected(fieldName: DefaultPackageConfigurationFieldsType) {
    let fieldCopy = angular.copy(this.field);
    if (this.field.category === FieldCategoryType.Generic) {
      fieldCopy = this.settingsService.getGenericPackageConfigurationFieldByName(fieldName)
    }
    this.onFieldChanged({changedField: fieldCopy})
  }

  onOptionsAdded(items) {
    let fieldCopy = angular.copy(this.field);
    fieldCopy.options = angular.copy(items);
    this.onFieldChanged({changedField: fieldCopy})
  }

  onValidationEnabledChanged(validationEnabled) {
    let fieldCopy = angular.copy(this.field);
    if (!validationEnabled) {

      fieldCopy.validation = this._resetValidation(fieldCopy.validation, validationEnabled)

    } else if (validationEnabled && fieldCopy.type === FieldType.Numeric) {
      fieldCopy.validation.type = ValidationType.Numeric
    } else if (validationEnabled && (fieldCopy.type === FieldType.FreeText)) {
      fieldCopy.validation.type = ValidationType.RegularExpression
    }

    this.onFieldChanged({changedField: fieldCopy})
  }

  onCustomFieldSelect(customField: CustomFieldModel) {
    let fieldCopy = angular.copy(this.field);
    fieldCopy.packageFieldId = customField?.id;
    fieldCopy.name = customField?.name;
    fieldCopy.type = customField?.type;
    fieldCopy.options = customField?.fieldOptions;

    this.onFieldChanged({changedField: fieldCopy})
  }

  private _resetValidation(validation: FieldValidationModel, enabled: boolean) {
    validation.enabled = enabled;
    delete validation.type;
    delete validation.expression;
    delete validation.explanation;
    return validation;
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationFieldTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      field: '<',
      isEditable: '<?',
      genericFieldNameOptions: '<?',
      isGeneric: '<?',
      isDefault: '<?',
      onFieldChanged: '&?',
      onDeleteField: '&?'
    },
    template: require('./package-configuration-field-table-row.html').default,
    controller: PackageConfigurationFieldTableRowComponent
  });

